import { render } from "./vue3-animate-number.vue?vue&type=template&id=5381154d"
import script from "./vue3-animate-number.vue?vue&type=script&lang=js"
export * from "./vue3-animate-number.vue?vue&type=script&lang=js"

import "./vue3-animate-number.vue?vue&type=style&index=0&id=5381154d&lang=css"
script.render = render

export default script